import { localize } from "utils/localizer";

const i18n = {
    accounting: {
        en: "Accounting",
        de: "Abrechnungen",
    },
    accountingReport: {
        en: "Monthly report",
        de: "Monatsabrechnung",
    },
    all: {
        en: "All",
        de: "Alle",
    },
    amount: {
        en: "Amount",
        de: "Betrag",
    },
    anErrorOccurred: {
        en: "An error occurred",
        de: "Ein Fehler ist aufgetreten",
    },
    bookingOf: {
        en: "Booking of",
        de: "Buchung vom",
    },
    cancel: {
        en: "Cancel",
        de: "Abbrechen",
    },
    club: {
        en: "Location",
        de: "Organisation",
    },
    documents: {
        en: "Documents",
        de: "Dokumente",
    },
    documentsDesc: {
        en: "Here you can download all important documents:",
        de: "Hier kannst du alle wichtigen Dokumente herunterladen:",
    },
    download: {
        en: "Download",
        de: "Herunterladen",
    },
    errors: {
        en: {
            noInvoicesFound: "No invoices to export found.",
        },
        de: {
            noInvoicesFound: "Keine Rechnungen zum Exportieren vorhanden.",
        },
    },
    export: {
        en: "Export",
        de: "Exportieren",
    },
    invoices: {
        en: "Invoices",
        de: "Einzelrechnung",
    },
    playsportsInvoice: {
        en: "PLAYSPORTS invoice",
        de: "PLAYSPORTS Rechnung",
    },
    recipient: {
        en: "Recipient",
        de: "Adressat",
    },
    reportType: {
        en: "Report type",
        de: "Berichtstyp",
    },
    reports: {
        en: "Reports",
        de: "Abrechnung",
    },
    revenue: {
        en: "Revenue",
        de: "Umsatz",
    },
    thisMayTakeAWhile: {
        en: (mail: string) => `The export may take a while. Upon completion, a mail will be sent to ${mail}.`,
        de: (mail: string) => `Der Export kann etwas Zeit in Anspruch nehmen. Nach Fertigstellung wird eine Mail an ${mail} versandt.`,
    },
    timePeriod: {
        en: "Time period",
        de: "Zeitraum",
    },
    expenseReport: {
        en: "Invoice",
        de: "Rechnung",
    },
    expense: {
        en: "Expenses",
        de: "Kosten",
    },
};

export default localize(i18n);
